export default __webpack_public_path__ + "static/media/dashboard.b6e7a400.jpg";